import "./ToastHostedCheckout.scss";

export const ToastHostedCheckout = () => {
    return null;
};
